import { makeRestApiRequest } from '~src/httpClient/RestApiService';

import { IPackage } from '../../models/IPackage';
import { API_VERSION, PACKAGES_PATH } from '../constants/RestApiConstants';

// overwrite=true atomically replaces an existing package with the same manifest
// id; the default returns 409 with PACKAGE_ALREADY_EXISTS.
export interface IPublishPackageResponse {
  package?: IPackage;
}

export class PublishPackageService {
  public static publishPackage(archive: File, overwrite: boolean): Promise<IPublishPackageResponse> {
    const formData = new FormData();
    formData.append('archive', archive);

    return makeRestApiRequest<FormData, IPublishPackageResponse, { overwrite: boolean }>({
      restApiVersion: API_VERSION,
      httpMethod: 'POST',
      endpoint: PACKAGES_PATH,
      requestBody: formData,
      queryParams: { overwrite },
      headers: { 'Accept': 'application/json' },
    });
  }
}
